/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on Sep 12, 2026 by hoarfroster
 *
 */

const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Collect focusable elements inside a container in DOM order. */
export function getFocusableElements(container: HTMLElement): HTMLElement[] {
    return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
}

/**
 * Keep Tab focus cycling inside `container`. Returns true when the event was
 * handled (callers should skip their default ESC/Tab handling then).
 */
export function trapTabKey(event: KeyboardEvent, container: HTMLElement): boolean {
    if (event.key !== 'Tab') return false;

    const focusable = getFocusableElements(container);
    if (focusable.length === 0) return false;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    const inside = active instanceof Node && container.contains(active);

    if (event.shiftKey) {
        if (active === first || !inside) {
            event.preventDefault();
            last.focus();
            return true;
        }
    } else if (active === last || !inside) {
        event.preventDefault();
        first.focus();
        return true;
    }
    return false;
}
